import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import LotSearchFormResult from "../maintabs/lot/LotSearchFormResult";
import LotSearchForm from "../maintabs/lot/LotSearchForm";

const WMLotDetailsWithCustomer = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/TransactionManagement/GetAllLots";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("Lots");
    const accessToken = props.oidc.user.access_token;

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                lotCode: () => formFields.lotCode,
                lotDescription1: () => formFields.lotDescription1,
                RCustomer: () => formFields.R_CUSTOMER,
                customerName: () => formFields.customerName,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LotSearchForm pageTitle={pageTitle} searchData={searchData} />
                        <LotSearchFormResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMLotDetailsWithCustomer);
